enum ModeOfTravel {
    CYCLE = "Cycle",
    BIKE = "Bike/Scooty",
    WALK = "Walk"
}

export default ModeOfTravel